module.exports = __webpack_public_path__ + "static/media/OpenSans-SemiBold.e2ca235b.ttf";